import { useStyles } from '@webapps/styles';
import { ArrowRightAlt } from '@material-ui/icons';
import { Grid } from '@material-ui/core';
import { getBillingsStats } from '@webapps/business';
import { useAuth, useQuery } from '@webapps/reactjs-tech-components';
import { useHistory } from 'react-router-dom';
import { ROUTES_PATH } from 'config/constants';
import { InfoTooltip } from '@webapps/styles';

export default function Accounting() {
  const { classes, global } = useStyles(styles);
  const { idUser } = useAuth();
  const { push } = useHistory();

  const buttonData = [
    { title: 'Factures transmises', value: 'TRANSMIS', arrow: -45, color: '#c0d9ff', iconColor: '#0060f9', big: false },
    { title: 'Factures à venir', value: 'A_VENIR', arrow: -45, color: '#fae8d7', iconColor: '#FA8100', big: false },
    { title: 'Factures en cours de règlement', value: 'EN_COURS_REGLEMENT', arrow: -45, color: '#e9d5fb', iconColor: '#8631d6', big: false },
    { title: 'Factures à envoyer', value: 'CREATED', arrow: -45, color: '#fad7ee', iconColor: '#c2278c', big: false },
    { title: 'Factures réglées', value: 'REGLE', arrow: -45, color: '#dbfad8', iconColor: '#008000', big: true },
    { title: 'Factures non abouties', value: 'NON_ABOUTIES', arrow: 45, color: '#FBD3D5', iconColor: '#F50057', big: true },
  ];

  const { data: billingStats } = useQuery(getBillingsStats, {
    key: ['billingStats'],
    variables: { id: idUser },
    keepPreviousData: true,
  });

  const getAmountForStatus = (status) => {
    const stat = billingStats?.find((s) => s.status === status);
    const amount = stat ? stat.amount : 0;
    return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(amount);
  };

  const handleClick = (button) => {
    push(ROUTES_PATH.CFA_ACCOUNTING, { value: button.value });
  };

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <div className={global.title}>Votre comptabilité sur l'année</div>
        <InfoTooltip
          position="bottom"
          forceVisible={false}
          title="Comment ça marche ?"
          description="Retrouvez ici un résumé de votre comptabilité sur l'année, incluant les factures transmises, à venir, et leur statut de règlement."
          link={{ text: "En savoir plus" }}
        />
      </div>
      <Grid container>
        {buttonData.map((button, index) => (
          <Grid item xs={6} key={index} onClick={() => handleClick(button)}>
            <div className={classes.button}>
              <div className={classes.label}>{button.title}</div>
              <div className={classes.amountContainer}>
                <div className={classes.iconWrapper} style={{ backgroundColor: button.color }}>
                  <ArrowRightAlt className={classes.icon} style={{ fill: button.iconColor, transform: `rotate(${button.arrow}deg)` }} />
                </div>
                <p className={classes.amount}
                  style={{
                    fontSize: button?.big ? '20px' : '15px',
                  }}
                >{getAmountForStatus(button.value)}</p>
              </div>
            </div>
          </Grid>
        ))}
      </Grid>
    </div >
  );
}

const styles = ({ spacing }) => ({
  container: {
    backgroundColor: 'white',
    borderRadius: '10px',
    padding: '20px',
    flexDirection: 'column',
    gap: '20px',
    display: 'flex',
    overflow: 'visible',
  },
  header: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    gap: '6px',
    overflow: 'visible',
  },
  button: {
    alignItems: 'flex-start',
    backgroundColor: 'transparent',
    borderRadius: '10px',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'flex-start',
    padding: '16px',
    width: '100%',
    gap: '8px',
    cursor: 'pointer',
    overflow: 'hidden',
    '&:hover': {
      backgroundColor: '#f3f7ff',
      '& p': {
        color: '#0060f9',
      },
    },
  },
  label: {
    fontFamily: '"Roboto", sans-serif',
    fontSize: '12px',
    lineHeight: '12px',
    color: '#5d75a8',
  },
  amountContainer: {
    alignItems: 'center',
    alignSelf: 'stretch',
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
    overflow: 'hidden',
  },
  iconWrapper: {
    backgroundColor: '#c0d9ff',
    borderRadius: '5px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '2px',
  },
  icon: {
    height: '18px',
    width: '18px',
  },
  amount: {
    fontFamily: '"Montserrat", sans-serif',
    fontSize: '15px',
    fontWeight: 600,
    lineHeight: '20px',
    color: '#152652',
    margin: 0,
  },
});